/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable complexity */
/* eslint-disable no-magic-numbers */
import React, { useEffect, useState, useRef, useCallback } from "react";
import useUserLandedLocationEvent from "../../../hooks/use-user-landed-location-event";
import PropTypes from "prop-types";
import styles from "./styles.css";
import loadable from "@loadable/component";
import withLogin from "../with-login";
import {  trackDesktopCustomEventsAU, trackMobileCustomEventsAU, desktopCleverTapEvent } from "../../../tracking";
import { AU_DESKTOP_EVENTS, AU_DESKTOP_LANDING_PAGE_EVENTS } from "../../../tracking/au.desktop-events";
import { CLEVERTAP_EVENT_MAP } from "../../../tracking/au.desktop-clevertap";
import ArrowIcon from "../../shared/arrow";
import AvatarText from "../../shared/avatar-text/avatar-text";
import { appUrl, getLogoURLWhite } from "../../../constants/url-constants";
import { LOGIN_SOURCE, NUMBER, SEARCH_ALL_CARS_ROUTE } from "../../../au-c2b/constants/app-constants";
import { HELPLINE_NUMBER_AU, USER_LOGIN_STATUS } from "../../../constants/app-constants";
import { getItemFromSession, setItemInSession } from "../../../utils/helpers/session-storage";
import { SELECT_OFFER_SESSION_KEY } from "../../../constants/finance-constants";
import currentPathObject from "../../../utils/helpers/get-current-page";
import { GA_EVENTS } from "./tracking";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
// HeaderWishlist import removed - using custom wishlist button in new design
import useCustomHistoryOperations from "../../../hooks/use-custom-history-operation";
import RippleButton from "../../shared/ripple-button";
import UserLocationSelectorSkeleton from "../user-location-selector/skeleton";
import SearchRevamp from "../search-revamp";
import { redirectToUrl } from "../../../utils/helpers/redirect-to-url";

// New design assets
import australiaFlag from "./images/australia-flag.svg";
import chevronDownWhite from "./images/chevron-down-white.svg";
import phoneIcon from "./images/phone-icon.svg";
// searchIcon removed - using SearchRevamp component
import wishlistWhite from "./images/heart-white.svg";
import userIconWhite from "./images/user-icon-white.svg";
import HamburgerIcon from "./images/hamburger.svg";

const UserLocationSelector = loadable(() => import("../user-location-selector"), { fallback: <UserLocationSelectorSkeleton/> });

// eslint-disable-next-line max-statements
const Header = ({
    isLoggedIn,
    profileName,
    openLoginPopupConnect,
    seoMenu = {},
    fixed = false,
    preApproved,
    userTradeInData,
    email,
    logoutConnect,
    setTradeInToggleSelectedConnect,
    resetWishlistConnect,
    wishlistedCarsList,
    userGeoData,
    setOnLoginSuccessCallback,
    checkAndOpenSecondaryModalConnect
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [showToolTip, setShowToolTip] = useState(false);
    const [showLocationDropdown, setShowLocationDropdown] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isHydrated, setIsHydrated] = useState(false);
    useEffect(() => { setIsHydrated(true); }, []);
    const totalWishlistedCars = isHydrated ? (wishlistedCarsList?.length || 0) : 0;
    const headerDropRef = useRef(null);
    const profileHeader = useRef(null);
    const headerLocationRef = useRef(null);
    const { customPush } = useCustomHistoryOperations();

    const landedLocationPayload = useUserLandedLocationEvent();
    const hasFiredLandedLocationEventRef = useRef(false);

    const {city: {name: cityName} = {}} = userGeoData || {};

    const handleClickOutside = event => {
        if (profileHeader.current && !profileHeader.current.contains(event.target)) {
            setShowDropdown(false);
        }
        if (headerLocationRef.current && !headerLocationRef.current.contains(event.target)) {
            setShowLocationDropdown(false);
        }
    };

    useEffect(() => {
        if (!showDropdown && !showLocationDropdown) {
            return () => {};
        }
        window.setTimeout(() => document.addEventListener("click", handleClickOutside, false));
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, [showDropdown, showLocationDropdown]);

    useEffect(() => {
        const { eventAction = "", eventLabel = "" } = landedLocationPayload || {};

        if (!eventAction || hasFiredLandedLocationEventRef.current) {
            return;
        }
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.USER_LANDED_LOCATION, {
            eventAction,
            eventLabel
        });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.USER_LANDED_LOCATION_TEST, {
            eventAction,
            eventLabel: ""
        });
        desktopCleverTapEvent(CLEVERTAP_EVENT_MAP.USER_LANDED_LOCATION, {
            eventAction,
            eventLabel
        });
        hasFiredLandedLocationEventRef.current = true;
    }, [landedLocationPayload, userGeoData]);

    useEffect(() => {
        if ((preApproved || userTradeInData.tradeIn) && getItemFromSession("showFinanceTradeNudge") === null) {
            setShowToolTip(true);
            setItemInSession("showFinanceTradeNudge", true);
            window.setTimeout(() => {
                setShowToolTip(false);
                setItemInSession("showFinanceTradeNudge", false);
            }, NUMBER.THREE_THOUSAND);
        }
    }, [preApproved, userTradeInData.tradeIn]);

    const onClickLoginSignup = async (e) => {
        setLoading(true);
        e.preventDefault();
        openLoginPopupConnect();
        setOnLoginSuccessCallback(() => checkAndOpenSecondaryModalConnect());
        setLoading(false);
        await yieldToMain();
        trackMobileCustomEventsAU(AU_DESKTOP_EVENTS.LOGIN_INITIATED, {
            eventLabel: LOGIN_SOURCE.HAMBURGER
        });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.HAMBURGER_MENU_OPTIONS, {
            eventLabel: `option selected login`
        });
    };

    const onClickExpandMenu = () => {
        setShowDropdown(!showDropdown);
    };

    const onClickLogout = (e) => {
        e.preventDefault();
        setShowDropdown(false);
        logoutConnect(() => setTradeInToggleSelectedConnect(null));
        resetWishlistConnect();
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.HAMBURGER_MENU_OPTIONS, {
            eventLabel: `option selected logout`
        });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.SIGNOUT, {
            user_id: email,
            user_status: USER_LOGIN_STATUS.LOGGED_OUT
        });
        const selectOfferBackButtonSession = window.sessionStorage.getItem(SELECT_OFFER_SESSION_KEY);
        if (selectOfferBackButtonSession) window.sessionStorage.removeItem(SELECT_OFFER_SESSION_KEY);
    };

    const navigateToWishlist = async(e) => {
        e.preventDefault();
        if (!isLoggedIn) {
            openLoginPopupConnect(true);
            setOnLoginSuccessCallback(() => customPush("/wishlist/"));
        } else {
            await customPush("/wishlist/");
        }

        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.HEADER_WISHLIST_OPEN);
    };

    const {isDetailsPage, isHomePage, isListingPage} = currentPathObject() || {};

    const navigateToMyBookings = async (e) => {
        e.preventDefault();
        await customPush("/my-bookings/");
        window.setTimeout(() => {
            if (isDetailsPage || isHomePage || isListingPage) {
                let location;
                if (isDetailsPage) {
                    location = "CDP";
                } else if (isHomePage) {
                    location = "Homepage";
                } else location = "CLP";
                trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.MY_BOOKINGS_LANDING, {
                    event: "custom_event",
                    eventCategory: "My Bookings opened",
                    eventAction: "location",
                    eventLabel: location
                });
            }
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.HEADER_WISHLIST_OPEN);
        }, NUMBER.HUNDRED);
    };

    const navigateToMyAccount = (e) => {
        e.preventDefault();
        redirectToUrl({ relativeURL: "/my-account/" });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.HEADER_WISHLIST_OPEN);
    };

    const navigateToSellOrders = (e) => {
        e.preventDefault();
        redirectToUrl({ relativeURL: "/my-sell-orders/" });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.MENU_YOUR_ORDERS);
    };

    const trackEvent = useCallback((e, label) => {
        const eventLabel = label || (e && e.target.getAttribute("data-event"));
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.HEADER_PAGE_SELECTED, { eventLabel });
    }, []);

    const handleNavHover = useCallback((navLabel) => {
        if (isHomePage) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TOP_NAV_HOVERED, {
                eventLabel: navLabel
            });
        }
    }, [isHomePage]);

    const handleNavClick = useCallback((eventLabel) => {
        if (isHomePage) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TOP_NAV_CLICK, {
                eventLabel
            });
        }
    }, [isHomePage]);

    const trackSpathEvent = (eventLabel) => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.HEADER_BUY_A_CAR, {eventLabel});
    };

    const closeToolTip = () => {
        setShowToolTip(false);
    };

    const handleCars24FinanceClicked = async (e) => {
        e.preventDefault();
        await yieldToMain();
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.MENU_FINANCING_CLICKED, {
            eventAction: "Clicked",
            eventLabel: "Yes"
        });
        redirectToUrl({ relativeURL: "/cars24-finance/" });
    };

    const handleRoadWorthyClick = async (e) => {
        e.preventDefault();
        await yieldToMain();
        trackDesktopCustomEventsAU(GA_EVENTS.RWC_SECTION_ENTERED, GA_EVENTS.RWC_SECTION_ENTERED);
        redirectToUrl({ relativeURL: "/roadworthy-certificate-melbourne/" });
    };

    const handleCarHistoryClick = async (e) => {
        e.preventDefault();
        await yieldToMain();
        trackDesktopCustomEventsAU(
            GA_EVENTS.CHR_LANDING_PAGE, {
                ...GA_EVENTS.CHR_LANDING_PAGE
            });
        redirectToUrl({ relativeURL: "/car-history-check/" });
    };

    const {makeUrl = [], makeModelUrl = [], fuelUrl = [], bodyUrl = [], cityTypeUrl = []} = seoMenu || {};

    const toggleLocationModal = (e) => {
        if (e) {
            e.preventDefault();
        }
        if (isHomePage && !showLocationDropdown) {
            trackDesktopCustomEventsAU(AU_DESKTOP_LANDING_PAGE_EVENTS.LOCATION_CLICKED);
        }
        setShowLocationDropdown(!showLocationDropdown);
    };

    return (
        <div styleName={`styles.headerWrapper ${fixed ? "styles.headerFixed" : ""}`} className="pre_exit_header">
            <div styleName="styles.topHeader">
                <div styleName="styles.topHeaderContainer">
                    <div styleName="styles.topHeaderLeft">
                        <div styleName="styles.flagContainer">
                            <img src={australiaFlag} alt="Australia" width="21" height="15" />
                        </div>
                        <a onClick={toggleLocationModal} styleName="styles.locationSelector" href="/">
                            <span styleName="styles.cityName">{cityName || ""}</span>
                            <img  src={chevronDownWhite} alt="dropdown" width="12" height="12" />
                        </a>
                    </div>
                    <div styleName="styles.topHeaderRight">
                        <a href={`tel:${HELPLINE_NUMBER_AU.value}`} styleName="styles.phoneLink">
                            <img src={phoneIcon} alt="phone" width="16" height="16" />
                            <span>Call us {HELPLINE_NUMBER_AU.label}</span>
                        </a>
                    </div>
                </div>
            </div>

            {/* Main Navigation */}
            <div styleName="styles.mainNav">
                <div styleName="styles.mainNavContainer">
                    {/* Logo */}
                    <div styleName="styles.logoContainer">
                        <a href={appUrl()} styleName="styles.logoLink">
                            <img src={getLogoURLWhite()} alt="Cars24" width="132" height="28" />
                        </a>
                    </div>

                    {/* Search Bar */}
                    <div styleName="styles.searchBarWrapper">
                        <SearchRevamp isHeader={true}  />
                    </div>

                    {/* Profile Section */}
                    <div styleName="styles.profileSection" ref={profileHeader}>
                        {/* Wishlist */}
                        <a onClick={navigateToWishlist} styleName="styles.wishlistBtn" href="/wishlist/">
                            <img src={wishlistWhite} alt="wishlist" width="20" height="20" />
                            {totalWishlistedCars > 0 && (
                                <span styleName="styles.wishlistCount">{totalWishlistedCars}</span>
                            )}
                        </a>

                        {/* Login Button */}
                        {isHydrated && isLoggedIn && (
                            <a onClick={onClickExpandMenu} styleName="styles.loginBtnLoggedIn">
                                <AvatarText allInitials={false} fullName={profileName} email={email} />
                                <img src={HamburgerIcon} alt="hamburger" width="16" height="16" />
                            </a>
                        )}
                        {isHydrated && !isLoggedIn && loading && (
                            <i className="spinner" styleName="styles.loginSpinner"/>
                        )}
                        {(!isHydrated || (!isLoggedIn && !loading)) && (
                            <a onClick={onClickLoginSignup} styleName="styles.loginBtn">
                                <img src={userIconWhite} alt="login" width="16" height="16" />
                                <span>Login</span>
                            </a>
                        )}

                        {/* Dropdown Menu */}
                        {showDropdown && (
                            <ul styleName="styles.dropdownMenu">
                                <li><a onClick={navigateToMyBookings} href="#">My bookings</a></li>
                                <li><a onClick={navigateToSellOrders} href="#">My sell orders</a></li>
                                <li><a onClick={navigateToMyAccount} href="#">My Account</a></li>
                                <li><a href="#" onClick={onClickLogout}>Logout</a></li>
                            </ul>
                        )}

                        {showToolTip && (
                            <span styleName="styles.toolTipWrapper">
                                <p styleName="styles.tooltipTextOne">My account</p>
                                <p styleName="styles.tooltipTextTwo">View and modify all details related to <span>finance</span> and <span>trade-in</span></p>
                                <a styleName="styles.tooltipGetIt" onClick={closeToolTip}>Got it</a>
                            </span>
                        )}
                    </div>
                </div>
            </div>

            {/* Sub Menu with Dropdowns */}
            <div styleName="styles.subMenu">
                <div styleName="styles.subMenuContainer">
                    <ul styleName="styles.subMenuList" onClick={trackEvent}>
                        {/* Buy a car with mega dropdown */}
                        <li styleName="styles.subMenuItem styles.subMenuDropdown" onMouseEnter={() => handleNavHover("Buy")}>
                            <a data-event="find_car">Buy a car <ArrowIcon rebrand={true} /></a>
                            <div styleName="styles.megaDropdown">
                                <div styleName="styles.listOuter">
                                    <h6>Popular makes</h6>
                                    <ul>
                                        {(makeUrl || []).map((item) => (
                                            <li key={item?.label}>
                                                <a href={`${appUrl()}/${item.spath}`} onClick={() => { trackSpathEvent(AU_DESKTOP_EVENTS.POPULAR_MAKE + item.spath); handleNavClick(`Buy_Popular_Makes_${item?.label}`); }}>{item?.label}</a>
                                            </li>
                                        ))}
                                    </ul>
                                    <a href={`${appUrl()}${SEARCH_ALL_CARS_ROUTE}/`} styleName="styles.viewAll" onClick={() => handleNavClick("Buy_Popular_Makes_View_all")}>View all makes</a>
                                </div>
                                <div styleName="styles.listOuter">
                                    <h6>Popular models</h6>
                                    <ul>
                                        {(makeModelUrl || []).map((item) => (
                                            <li key={item?.label}>
                                                <a href={`${appUrl()}/${item.spath}`} onClick={() => { trackSpathEvent(AU_DESKTOP_EVENTS.POPULAR_MODEL + item.spath); handleNavClick(`Buy_Popular_Models_${item?.label}`); }}>{item?.label}</a>
                                            </li>
                                        ))}
                                    </ul>
                                    <a href={`${appUrl()}${SEARCH_ALL_CARS_ROUTE}/`} styleName="styles.viewAll" onClick={() => handleNavClick("Buy_Popular_Models_View_all")}>View all models</a>
                                </div>
                                <div styleName="styles.listOuter">
                                    <h6>Body Type</h6>
                                    <ul>
                                        {(bodyUrl || []).map((item) => (
                                            <li key={item?.label}>
                                                <a href={`${appUrl()}/${item.spath}`} onClick={() => { trackSpathEvent(AU_DESKTOP_EVENTS.FUEL_TYPE_SELECTED + item.spath); handleNavClick(`Buy_Body_Type_${item?.label}`); }}>{item?.label}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div styleName="styles.listOuter">
                                    <h6>Fuel Type</h6>
                                    <ul>
                                        {(fuelUrl || []).map((item) => (
                                            <li key={item?.label}>
                                                <a href={`${appUrl()}/${item.spath}`} onClick={() => { trackSpathEvent(AU_DESKTOP_EVENTS.BODY_TYPE_SELECTED + item.spath); handleNavClick(`Buy_Fuel_Type_${item?.label}`); }}>{item?.label}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div styleName="styles.listOuter">
                                    <h6>Location</h6>
                                    <ul>
                                        {(cityTypeUrl || []).map((item) => (
                                            <li key={item?.label}>
                                                <a href={`${appUrl()}/${item.spath}`} onClick={() => {
                                                    trackSpathEvent(AU_DESKTOP_EVENTS.BODY_TYPE_SELECTED + item.spath);
                                                    handleNavClick(`Buy_Location_${item?.label}`);
                                                }}>{item?.label}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </li>

                        {/* Sell / Trade-in */}
                        <li styleName="styles.subMenuItem" onMouseEnter={() => handleNavHover("Sell")}>
                            <a
                                href="/sell-my-car/"
                                data-event="sellCarClicked"
                                onClick={(e) => {
                                    e.preventDefault();
                                    redirectToUrl({ relativeURL: "/sell-my-car/" });
                                    trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.SELL_OR_TRADE_IN_CAR);
                                    handleNavClick("Sell");
                                }}
                            >
                                Sell / Trade-in
                            </a>
                        </li>

                        {/* Car Finance with dropdown */}
                        <li styleName="styles.subMenuItem styles.subMenuDropdown" onMouseEnter={() => handleNavHover("Finance")}>
                            <a data-event="finance" ref={headerDropRef}>
                                Car Finance <ArrowIcon rebrand={true} />
                            </a>
                            <ul styleName="styles.subMenuDropdownList">
                                <li><a data-event="financingClicked"
                                    href={isLoggedIn ? `${appUrl()}/my-account/financing/` : `${appUrl()}/financing/get-pre-approval/`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        redirectToUrl({ relativeURL: isLoggedIn ? "/my-account/financing/" : "/financing/get-pre-approval/" });
                                        handleNavClick("Car_Finance_Apply");
                                    }}>Apply for pre-approval
                                </a></li>
                                <li><a data-event="cars24Finance" href={`${appUrl()}/cars24-finance/`} onClick={(e) => { handleCars24FinanceClicked(e); handleNavClick("Car_Finance_Cars24_Finance"); }}>Cars24 Finance</a></li>
                            </ul>
                        </li>

                        {/* Services with dropdown */}
                        <li styleName="styles.subMenuItem styles.subMenuDropdown" onMouseEnter={() => handleNavHover("Services")}>
                            <a data-event="services" style={{ position: "relative", overflow: "hidden" }}><RippleButton/> Services <ArrowIcon  rebrand={true} /></a>
                            <ul styleName="styles.subMenuDropdownList">
                                <li styleName="styles.carTrust"><a data-event="vehicleHistory"
                                    href={`${appUrl()}/car-history-check/`}
                                    onClick={(e) => { handleCarHistoryClick(e); handleNavClick("Services_CHR"); }}>Check vehicle history <span>New</span>
                                </a></li>
                                <li><a data-event="rwc"
                                    href={`${appUrl()}/roadworthy-certificate-melbourne/`}
                                    onClick={(e) => { handleRoadWorthyClick(e); handleNavClick("Services_RWC"); }}>Roadworthy certificate
                                </a></li>
                            </ul>
                        </li>

                        {/* How it works with dropdown */}
                        <li styleName="styles.subMenuItem styles.subMenuDropdown" onMouseEnter={() => handleNavHover("Howitworks")}>
                            <a data-event="howitworks">How it works <ArrowIcon  rebrand={true} /></a>
                            <ul styleName="styles.subMenuDropdownList">
                                {/* <li><a data-event="CARS24_Quality_Standards" href={`${appUrl()}/car-quality-standards-cars24/`} target="_blank" onClick={() => handleNavClick("How_it_works_Standards")}>Cars24 Quality Standards</a></li> */}
                                <li><a data-event="CARS24_way" href={`${appUrl()}/thecars24way/`} onClick={(e) => { e.preventDefault(); redirectToUrl({ relativeURL: "/thecars24way/" }); handleNavClick("How_it_works_Cars24_way"); }}>The Cars24 Way</a></li>
                                <li><a data-event="cars24Cover" href={`${appUrl()}/cars24cover/`} onClick={(e) => { e.preventDefault(); redirectToUrl({ relativeURL: "/cars24cover/" }); handleNavClick("How_it_works_Cover"); }}>Cars24 Platinum Cover™</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>

            {/* Divider */}
            <div styleName="styles.headerDivider" />

            {/* Location Dropdown */}
            {showLocationDropdown && (
                <div styleName="styles.locationDropdownOuter" ref={headerLocationRef}>
                    <UserLocationSelector onClose={toggleLocationModal} />
                </div>
            )}
        </div>
    );
};

Header.propTypes = {
    isLoggedIn: PropTypes.bool,
    fixed: PropTypes.bool,
    profileName: PropTypes.string,
    logoutConnect: PropTypes.func,
    resetWishlistConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    openLoginPopupConnect: PropTypes.func,
    clearAllFiltersConnect: PropTypes.func,
    seoMenu: PropTypes.object,
    preApproved: PropTypes.bool,
    userTradeInData: PropTypes.object,
    email: PropTypes.string,
    setTradeInToggleSelectedConnect: PropTypes.func,
    setOnLoginSuccessCallback: PropTypes.func,
    wishlistedCarsList: PropTypes.array,
    userGeoData: PropTypes.object,
    checkAndOpenSecondaryModalConnect: PropTypes.func
};

export default withLogin(Header);
